import React from 'react';

const IconLogo = () => (
  // <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
  //   <title>Logo</title>
  //   <g transform="translate(-8.000000, -2.000000)">
  //     <g transform="translate(11.000000, 5.000000)">
  //       <path
  //         d="M45.691667,45.15 C48.591667,46.1 50.691667,48.95 50.691667,52.2 C50.691667,57.95 46.691667,61 40.291667,61 L28.541667,61 L28.541667,30.3 L39.291667,30.3 C45.691667,30.3 49.691667,33.15 49.691667,38.65 C49.691667,41.95 47.941667,44.35 45.691667,45.15 Z M33.591667,43.2 L39.241667,43.2 C42.791667,43.2 44.691667,41.85 44.691667,38.95 C44.691667,36.05 42.791667,34.8 39.241667,34.8 L33.591667,34.8 L33.591667,43.2 Z M33.591667,47.5 L33.591667,56.5 L40.191667,56.5 C43.691667,56.5 45.591667,54.75 45.591667,52 C45.591667,49.2 43.691667,47.5 40.191667,47.5 L33.591667,47.5 Z"
  //         fill="currentColor"
  //       />
  //       <polygon
  //         id="Shape"
  //         stroke="currentColor"
  //         strokeWidth="5"
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //         points="39 0 0 22 0 67 39 90 78 68 78 23"
  //       />
  //     </g>

  //   </g>
  // </svg>
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1023.75 1023.75">
    <defs></defs>
    <title>logo</title>
    <rect
      class="a"
      style={{
        fill: 'none',
        stroke: '#d3c0cd',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '14px',
      }}
      x="154.87"
      y="154.87"
      width="714"
      height="714"
      transform="translate(-212.03 511.87) rotate(-45)"
    />
    <polygon
      strokeWidth="5"
      class="b"
      fill="#d3c0cd"
      points="511.87 328.75 368.95 471.67 321.66 424.37 511.87 234.16 702.09 424.37 654.79 471.67 511.87 328.75"
    />
    <path
      class="b"
      fill="#d3c0cd"
      d="M511.87,234.87l189.51,189.5L654.79,471,512.58,328.75l-.71-.71-.7.71L369,471l-46.59-46.59,189.5-189.5m0-1.41L321,424.37l48,48L511.87,329.46,654.79,472.37l48-48L511.87,233.46Z"
    />
    <rect
      class="b"
      fill="#d3c0cd"
      x="331.26"
      y="488.69"
      width="66.88"
      height="54.86"
      transform="translate(-258.14 409.05) rotate(-45)"
    />
    <path
      class="b"
      fill="#d3c0cd"
      d="M369,473.79,407,511.87l-46.58,46.59-38.09-38.09L369,473.79m0-1.42-48,48,39.5,39.5,48-48L369,472.37Z"
    />
    <rect
      class="b"
      fill="#d3c0cd"
      x="631.61"
      y="482.68"
      width="54.86"
      height="66.88"
      transform="translate(-171.93 617.18) rotate(-45)"
    />
    <path
      class="b"
      fill="#d3c0cd"
      d="M654.79,473.79l46.59,46.58-38.09,38.09-46.58-46.59,38.08-38.08m0-1.42-39.5,39.5,48,48,39.5-39.5-48-48Z"
    />
    <polygon
      class="b"
      fill="#d3c0cd"
      points="321.66 599.37 360.45 560.58 511.87 712 663.29 560.58 702.09 599.37 511.87 789.59 321.66 599.37"
    />
    <path
      class="b"
      fill="#d3c0cd"
      d="M663.29,561.29l38.09,38.08L511.87,788.88,322.37,599.37l38.09-38.08L511.17,712l.7.71.71-.71L663.29,561.29m0-1.42L511.87,711.29,360.46,559.87,321,599.37,511.87,790.29,702.79,599.37l-39.5-39.5Z"
    />
    <rect
      class="b"
      fill="#d3c0cd"
      x="439.25"
      y="439.25"
      width="145.26"
      height="145.26"
      transform="translate(-212.03 511.87) rotate(-45)"
    />
    <path
      class="b"
      fill="#d3c0cd"
      d="M511.87,409.87l102,102-102,102-102-102,102-102m0-1.41L408.46,511.87,511.87,615.29,615.29,511.87,511.87,408.46Z"
    />
  </svg>
);

export default IconLogo;
